import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, watch } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";
import {
  filterAreaOption,
  mapAreaOptions,
  findAreaById,
  type AreaNode,
  type AreaSelectOption,
} from "./useArea";

interface Props {
  modelValue?: string | number | null;
  /** Danh sách phường/xã (thường lấy từ children của quận/huyện) */
  options?: AreaNode[];
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  showSearch?: boolean;
  loading?: boolean;
  status?: "" | "error" | "warning";
  notFoundContent?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WardSelect',
  props: {
    modelValue: { default: null },
    options: { default: () => [] },
    placeholder: { default: "Chọn Phường / Xã" },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    showSearch: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    status: { default: "" },
    notFoundContent: { default: "Không có dữ liệu" }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectOptions = computed(() => mapAreaOptions(props.options));

const innerValue = computed({
  get: () => props.modelValue,
  set: (val: string | number | null) => emit("update:modelValue", val),
});

watch(
  () => props.options,
  () => {
    if (
      props.modelValue != null &&
      !findAreaById(props.options, props.modelValue)
    ) {
      emit("update:modelValue", null);
      emit("change", null, null);
    }
  }
);

const onChange = (val: string | number | null, option: any) => {
  const selected = (option as AreaSelectOption) || null;
  emit("update:modelValue", val);
  emit("change", val, selected);
};

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    options: selectOptions.value,
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled || !selectOptions.value.length,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    "show-search": _ctx.showSearch,
    "filter-option": _unref(filterAreaOption),
    loading: _ctx.loading,
    status: _ctx.status,
    "not-found-content": _ctx.notFoundContent,
    class: "ant-ward-select",
    onChange: onChange
  }, null, 8, ["value", "options", "placeholder", "disabled", "size", "allow-clear", "show-search", "filter-option", "loading", "status", "not-found-content"]))
}
}

})